import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { OfferingMetadataPricingPlansSelector } from 'invision-core/src/components/metadata/offerings/offerings.selectors';
import { SelectedCustomerSelector } from './customer.selectors';
var ProductServiceRelationshipsStoreSelector = createImmutableSelector([SelectedCustomerSelector], function (selectedCustomer) {
  return selectedCustomer.productServiceRelationships;
});
export var ProductServiceRelationshipsSelector = createImmutableSelector([ProductServiceRelationshipsStoreSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), OfferingMetadataPricingPlansSelector], function (productServiceRelationshipsStore, allServiceAttribute, pricingPlanThumbnails) {
  return productServiceRelationshipsStore.data.map(function (item) {
    return Object.assign({}, item, {
      serviceAttributeName: item.NetworkIdentifierAttributeId && item.NetworkIdentifierAttributeId.Value && Object.keys(allServiceAttribute).length > 0 ? allServiceAttribute[item.NetworkIdentifierAttributeId.Value].Name : null,
      PricingPlanName: pricingPlanThumbnails["".concat(item.PricingPlanId.Value)].PricingPlanName,
      LinkableProviderPlans: (item.LinkableProviderPlans || []).map(function (providerPlan) {
        return Object.assign({}, providerPlan, {
          PricingPlanName: pricingPlanThumbnails["".concat(providerPlan.PricingPlanId.Value)].PricingPlanName
        });
      })
    });
  });
});
export var IsFetchingProductServiceRelationshipsSelector = createImmutableSelector([ProductServiceRelationshipsStoreSelector], function (productServiceRelationshipsStore) {
  return productServiceRelationshipsStore.isFetching;
});